import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import ChainedBackend from "i18next-chained-backend";
import resourcesToBackend from "i18next-resources-to-backend";

import enTranslations from "./locales/en.json";
import frTranslations from "./locales/fr.json";

const localResources = {
  en: enTranslations,
  fr: frTranslations
};

const I18N_BASE_URL = process.env.REACT_APP_I18N_BASE_URL;

const detectionOptions = {
  order: [
    "querystring",
    "navigator",
    "htmlTag",
    "cookie",
    "localStorage",
    "sessionStorage",
    "path",
    "subdomain",
  ],
};

if (!I18N_BASE_URL) {
  console.error("I18N_BASE_URL environment variable is missing!");
}

const backendsArray = [];
const backendOptionsArray = [];

if (I18N_BASE_URL) {
  backendsArray.push(HttpBackend);
  backendOptionsArray.push({
    loadPath: `${I18N_BASE_URL}/{{lng}}.json`,
  });
}

backendsArray.push(resourcesToBackend(localResources));
backendOptionsArray.push({});

const i18nInitPromise = i18n
  .use(ChainedBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      backends: backendsArray,
      backendOptions: backendOptionsArray,
    } as any,
    load: "languageOnly",
    partialBundledLanguages: true,
    detection: detectionOptions,
    fallbackLng: "en",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",
    nsSeparator: "",

    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
      transEmptyNodeValue: "i18n empty", // what to return for empty Trans
      transSupportBasicHtmlNodes: true, // allow <br/> and simple html elements in translations
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"], // don't convert to <1></1> if simple react elements
    },
  })
  .then(() => {
    // Merge local resources to fill missing keys from remote (per-key fallback)
    Object.entries(localResources).forEach(([lng, resources]) => {
      if (resources) {
        i18n.addResourceBundle(lng, "translations", resources, true, false);
      }
    });
    return i18n;
  });

export default i18n;
export { i18nInitPromise };
